import { IconButton, SvgIcon, SxProps, Theme } from '@mui/material';
import { shareIcon } from '../config/icons';

export type ShareButtonProps = {
  onClick: () => void;
  sx?: SxProps<Theme>;
};

export function ShareButton({ onClick, sx }: ShareButtonProps) {
  return (
    <IconButton
      onClick={onClick}
      data-treedistestid="button-share-content"
      sx={{
        height: '36px',
        width: '36px',
        borderRadius: '6px',
        ...sx,
      }}
    >
      <SvgIcon sx={{ width: { xs: '20px', sm: '25px' } }}>{shareIcon}</SvgIcon>
    </IconButton>
  );
}
